import React from 'react';
import { useTranslation } from 'react-i18next';

import { General } from 'icons/untitledui';
import * as StepStyled from 'shiftNotes/styles/InstantReflex/ReflexStepCard.style';
import * as DemoStyled from 'shiftNotes/styles/InstantReflex/DemoInstantReflexCard.style';

export default function DemoTranslateToggle(): JSX.Element {
  const { t } = useTranslation('pageShiftNotes');
  return (
    <DemoStyled.TranslateRow>
      <StepStyled.ActionPill
        type="button"
        onMouseDown={(event) => event.preventDefault()}
        aria-label={t('demoReflex.translate')}
      >
        <General.Translate01 />
        {t('demoReflex.translate')}
      </StepStyled.ActionPill>
    </DemoStyled.TranslateRow>
  );
}
